import { useQuery } from "@tanstack/react-query";
import { api, imgUrl } from "@/lib/api";
import { rp, fmtDateTime } from "@/lib/format";
import { useSeo } from "@/lib/shop";
import { ProductGrid } from "@/components/site/ProductCard";
import { GridSkeleton, Empty, ErrorState } from "@/components/site/States";
import { DemoBadge } from "@/components/site/Badges";

export default function Promo() {
  useSeo("Promo", "Promo dan diskon aktif di Bengkel Toys & Hobbies Pontianak.");
  const { data: banner } = useQuery({ queryKey: ["banners", "promo"], queryFn: () => api.get("/banners", { params: { placement: "promo" } }).then((r) => r.data[0]) });
  const { data, isLoading, isError, refetch } = useQuery({ queryKey: ["promos"], queryFn: () => api.get("/promos").then((r) => r.data) });
  return (
    <div data-testid="promo-page">
      <section className="relative overflow-hidden bg-[var(--bk-red)] text-white border-b-2 border-neutral-900">
        {banner?.image_desktop && <img src={imgUrl(banner.image_desktop)} alt="" className="absolute inset-0 h-full w-full object-cover opacity-35" />}
        <div className="absolute inset-0 halftone opacity-30" />
        <div className="relative container-x py-12 sm:py-16">
          <h1 className="font-display text-4xl sm:text-6xl [text-shadow:3px_3px_0_#111]">{banner?.title || "PROMO"}</h1>
          <p className="mt-3 max-w-xl text-white/90">{banner?.subtitle}</p>
        </div>
      </section>
      <div className="container-x py-10 space-y-14">
        {isLoading ? <GridSkeleton /> : isError ? <ErrorState onRetry={refetch} /> : !data.length ? (
          <Empty title="Belum ada promo aktif" text="Pantau terus halaman ini dan Instagram kami untuk promo berikutnya." />
        ) : data.map((pr) => (
          <section key={pr.id} data-testid={`promo-section-${pr.slug}`}>
            <div className="rounded-2xl border-2 border-neutral-900 bg-white overflow-hidden grid md:grid-cols-[1fr_280px]">
              <div className="p-6">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="font-display text-3xl text-[var(--bk-red)]">{pr.discount_type === "percent" ? `DISKON ${pr.value}%` : `POTONGAN ${rp(pr.value)}`}</span>
                  {pr.is_demo && <DemoBadge />}
                </div>
                <h2 className="font-heading text-2xl font-extrabold mt-1">{pr.title}</h2>
                {pr.description && <p className="text-neutral-700 mt-2">{pr.description}</p>}
                <p className="text-sm mt-3"><b>Periode:</b> {fmtDateTime(pr.start_at)} — {fmtDateTime(pr.end_at)}</p>
                {pr.terms && <p className="text-xs text-neutral-600 mt-2 whitespace-pre-line"><b>Ketentuan:</b> {pr.terms}</p>}
              </div>
              {pr.banner_image && <img src={imgUrl(pr.banner_image)} alt={pr.title} loading="lazy" className="h-48 md:h-full w-full object-cover" />}
            </div>
            <div className="mt-6">{pr.products.length ? <ProductGrid items={pr.products} /> : <Empty title="Produk promo belum tersedia" />}</div>
          </section>
        ))}
      </div>
    </div>
  );
}
